"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDropdownArrowKeysNavigation = void 0;
const react_1 = require("react");
function useDropdownArrowKeysNavigation(isReadOnly, hasArrowKeysNavigation, options, onSelect, handleOpen) {
    const [focused, setFocused] = (0, react_1.useState)();
    const setFocusedOption = (isDown = true) => {
        if (focused === undefined) {
            if (isDown) {
                setFocused(0);
            }
        }
        else if (isDown && options && options.length && options.length > focused + 1) {
            setFocused(focused + 1);
        }
        else if (isDown && options && options.length && options.length === focused + 1) {
            setFocused(0);
        }
        else {
            setFocused(focused - 1 < 0 ? undefined : focused - 1);
        }
    };
    const handleArrowNavigation = (event) => {
        if (hasArrowKeysNavigation && !isReadOnly) {
            if (event.key === "ArrowUp") {
                event.preventDefault();
                setFocusedOption(false);
            }
            else if (event.key === "ArrowDown") {
                event.preventDefault();
                setFocusedOption();
            }
            else if (event.key === "Enter") {
                event.preventDefault();
                const selectedOption = focused || 0;
                if (options && options.length && options.length > selectedOption) {
                    if (onSelect) {
                        onSelect(options[selectedOption]);
                    }
                    if (handleOpen) {
                        handleOpen(false);
                    }
                }
            }
        }
    };
    return {
        focused,
        setFocused,
        handleArrowNavigation,
    };
}
exports.useDropdownArrowKeysNavigation = useDropdownArrowKeysNavigation;
//# sourceMappingURL=Dropdown.hooks.js.map